module.exports = __webpack_public_path__ + "img/ico_question--white.1f09fe20.svg";